export const homeHR = {

    //Slika
    "learn_more": "O usluzi",

    //About
    "about": "O usluzi",
    "about_text": "FINA Validator je internetska usluga Financijske agencije koja korisnicima omogućuje provjeru valjanosti kvalificiranog elektroničkog potpisa ili pečata i naprednog elektroničkog potpisa ili pečata uz podršku kvalificiranog certifikata prema normama za PAdES, XAdES i CAdES. Provjera valjanosti elektroničkog potpisa ili pečata provodi se prema eIDAS Uredbi i ETSI normama te korištenjem pouzdanih popisa kvalificiranih pružatelja usluga povjerenja država članica EU (engl. <i>Trusted list</i>).",
    "start_validating": "Započni validaciju",

    //Dropzone
    "fina_validator": "Validator",
    "signed_document": "Potpisani dokument*",
    "upload_signed_text": "Učitajte potpisani/pečatirani dokument (engl. attached signature/seal) ili odvojenu datoteku potpisa/pečata u slučaju kada su potpis/pečat i izvorni dokument međusobno razdvojeni (odvojen potpis/pečat; engl. detached signature/seal).",
    "original_document": "Izvorni dokument ",
    "upload_original_text": "Učitajte izvorni dokument u slučaj kada su dokument i njegov potpis/pečat međusobno razdvojeni (odvojen potpis/pečat; engl. detached signature/seal).",
    "upload_original_text_extra": "[1] Dokument je potrebno učitati samo ako se radi o odvojenom potpisu/pečatu (engl. detached signature/seal).",
    "validate_button": "Validiraj dokument",
    "validating": "Validiram...",

    //Validate
    "big_file": "Učitana datoteka je veća od dopuštenog...",
    "validate_new": "Validiraj novi dokument",
    "copy_info": "Ukoliko želite koristiti mogućnost naknadnog dohvata vaših izvještaja validacije, molimo vas spremite navedene poveznice. Poveznice možete kopirati pritiskom na gumb",

    //Perm links
    "cro": "Izvještaji na hrvatskom jeziku",
    "eng": "Izvještaji na engleskom jeziku",
    "validation_reports": "Izvještaji validacije",
    "simple_report": "Jednostavni izvještaj",
    "detailed_report": "Detaljni izvještaj",
    "diagnostic_report": "Dijagnostički izvještaj",
    "copy_simple": "Pritisni za kopiranje permanentne poveznice za jednostavni izvještaj!",
    "download_simple": "Pritisni za preuzimanje jednostavnog PDF izvještaja!",
    "print_simple": "Pritisni za printanje jednostavnog PDF izvještaja!",
    "copy_detailed": "Pritisni za kopiranje permanentne poveznice za detaljni izvještaj!",
    "download_detailed": "Pritisni za preuzimanje detaljnog PDF izvještaja!",
    "print_detailed": "Pritisni za printanje detaljnog PDF izvještaja!",
    "copy_diagnostic": "Pritisni za kopiranje permanentne poveznice za dijagnostički izvještaj!",
    "download_diagnostic": "Pritisni za preuzimanje dijagnostičkog PDF izvještaja!",
    "print_diagnostic": "Pritisni za printanje dijagnostičkog PDF izvještaja!",
    "no_signatures": "Učitani dokument nije potpisan...",

    //Instructions
    "user_guide": "Upute za korištenje web aplikacije FINA Validator.",
    "download_instructions": "Preuzmi upute za korištenje",

    //FAQ
    "faq": "Često postavljena pitanja",

    //Footer
    "info_contact": "Korisnička podrška: info@fina.hr / 0800 0080"

};